import { addToArrayRecord } from "@cervval.js/common/src/tools/collection.map.tools";
import { ColumnUid } from "./dayAgenda.types";
import { DayAgendaModel } from "./dayAgendaModel";

/**
 * @returns a map containing the items by columnUid
 */
export function getItemsByColumnUid<
    ItemObject,
    ColumnObject
>(items: ItemObject[], agendaModel: DayAgendaModel<ItemObject, ColumnObject>): { [columnUid: string]: ItemObject[] } {
    const itemsByColumnUid: { [columnUid: ColumnUid]: ItemObject[] } = {};
    for (const item of items) {
        const columnUids = agendaModel.getItemColumnUids(item);

        for (const colUid of columnUids) {
            addToArrayRecord(itemsByColumnUid, colUid, item);
        }
    }
    return itemsByColumnUid;
}
